module.exports = __webpack_public_path__ + "static/media/stories-menu.a63e06c3.svg";